<header class="help-header">

  <!-- Logo -->
  <div class="header-logo-section">
    <img src="./assets/images/logos/logo-dark.svg"
         alt="Andica Logo"
         class="andica-logo">
  </div>

  <!-- Search -->
  <div class="header-search-section justify-content-end">
    <div class="search-box">



      <input #searchInput
             style="cursor:pointer" 
             type="search"
             class="search-input"
             placeholder="Search..."
             [(ngModel)]="searchText"
             (input)="onSearch()" />
      <i class="fa fa-search search-icon"></i>
      <!--<i *ngIf="searchText"
         class="fa fa-times clear-icon"
         (click)="clearSearch()">
      </i>-->

    </div>
    </div>

    <!-- Profile -->
    <!--<div class="header-profile-section">

      <div class="profile-circle">
        <i class="fa fa-user"></i>
      </div>

    </div>-->

</header>
